// web/src/firebase/firebase.js
// ======================================================
//  Firebase – One Love (WEB) – ARQUIVO OFICIAL ÚNICO
// ======================================================

import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// ======================================================
//  CONFIG DO FIREBASE — One Love Web (Console)
//  ✅ storageBucket atualizado pro padrão firebasestorage.app
// ======================================================
const firebaseConfig = {
  apiKey: "AIzaSyBKdr2RdNLY5_l2gcOWNvi4oj6KX92kABk",
  authDomain: "one-love-e5d8a.firebaseapp.com",
  projectId: "one-love-e5d8a",
  storageBucket: "one-love-e5d8a.firebasestorage.app",
  messagingSenderId: "702784000108",
  appId: "1:702784000108:web:09a261574a02b60a8fc849",
};

// ======================================================
// ✅ Inicializa Firebase apenas 1x (sem duplicar)
// ======================================================
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// ======================================================
// ✅ Auth / Firestore / Storage
// ======================================================
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// ======================================================
// 🔎 DEBUG (aparece só no localhost)
// - Confirma qual apiKey e projectId o Web realmente carregou
// ======================================================
if (
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1")
) {
  try {
    console.log(
      "%c[WEB Firebase] Inicializado ✅",
      "color:#ff2b88; font-weight:bold;"
    );
    console.log("[WEB Firebase] apiKey:", auth.app?.options?.apiKey);
    console.log("[WEB Firebase] projectId:", auth.app?.options?.projectId);
    console.log("[WEB Firebase] authDomain:", auth.app?.options?.authDomain);
    console.log(
      "[WEB Firebase] storageBucket:",
      auth.app?.options?.storageBucket
    );
    console.log("[WEB Firebase] appId:", auth.app?.options?.appId);
  } catch (e) {
    console.warn("[WEB Firebase] Debug falhou:", e);
  }
}

export { app, auth, db, storage };
